import styled from 'styled-components';
import {media, styleHelpers, mixins} from '@pik/pik-ui';

const S = {};

S.MarketDays = styled.div`
  box-sizing: border-box;
  padding-top: ${({ sent }) => sent ? 196 : 97}px;
  
  @media ${media.max768} {
    padding-top: 27px;
  }
`;

S.Form = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 863px;
  margin: 0 auto;
`;

S.Title = styled.div`
  box-sizing: border-box;
  font-size: 64px;
  line-height: 74px;
  font-weight: ${styleHelpers.fontWeight.semiBold};
  margin-bottom: 32px;
  text-align: center;

  @media ${media.max768} {
    font-size: 32px;
    line-height: 38px;
    margin-bottom: 21px;
  }
`;

S.Descrition = styled.div`
  box-sizing: border-box;
  font-size: 24px;
  line-height: 30px;
  text-align: center;
  margin-bottom: 64px;

  @media ${media.max768} {
    font-size: 15px;
    line-height: 20px;
    margin-bottom: 31px;
  }
`;

S.Icons = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 512px;
  margin: 0 auto ${({ sent }) => sent ? 50 : 99}px;
  ${mixins.flex()};

  @media ${media.max768} {
    display: ${({ sent }) => sent ? 'block' : 'none'};
    margin-bottom: 32px;
  }
`;

S.Icon = styled.div`
  box-sizing: border-box;
  ${mixins.flex()};
  
  &:first-child {
    margin-right: 32px;
  }

  @media ${media.max768} {
    svg {
      width: 16px;
      height: 16px;
    }
    
    &:first-child {
      margin-right: 0;
      margin-bottom: 16px;
    }
  }
`;

S.IconText = styled.div`
  box-sizing: border-box;
  font-size: 20px;
  line-height: 20px;
  margin-left: 8px;

  @media ${media.max768} {
    margin-left: 4px;
    font-size: 15px;
    line-height: 20px;
  }
`;

S.Fields = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 512px;
  margin: 0 auto 32px;
`;

S.Field = styled.div`
  box-sizing: border-box;
  margin-bottom: 16px;
`;

S.TextFieldDescription = styled.div`
  font-size: 14px;
  line-height: 18px;
  margin-top: 8px;
`;

S.Button = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 512px;
  margin: 0 auto;
`;

S.Sent = styled.div`
  box-sizing: border-box;
  max-width: 512px;
  margin: 0 auto;
`;

S.SentIcon = styled.div`
  box-sizing: border-box;
  ${mixins.flex()};
  width: 64px;
  height: 64px;
  border: 4px solid ${styleHelpers.colors.gray};
  border-radius: ${styleHelpers.borderRadius.circular};
  margin: 0 auto 64px;
  
  svg {
    path {
      stroke: ${styleHelpers.colors.gray};
      }
    }
  }

  @media ${media.max768} {
    display: none;
  }
`;

S.SentTitle = styled.div`
  box-sizing: border-box;
  text-align: center;
  margin-bottom: 36px;
  font-size: 32px;
  line-height: 32px;
  font-weight: ${styleHelpers.fontWeight.semiBold};

  @media ${media.max768} {
    line-height: 38px;
  }
`;

S.SentDesc = styled.div`
  box-sizing: border-box;
  text-align: center;
  margin-bottom: 67px;
  font-size: 24px;
  line-height: 30px;

  @media ${media.max768} {
    font-size: 15px;
    line-height: 20px;
    margin-bottom: 32px;
  }
`;

S.SentButton = styled.div`
  box-sizing: border-box;
  ${mixins.flex()};
  
  .Icons {
    margin-top: -4px;
    
    svg {
      fill: ${styleHelpers.colors.secondaryAccent};
    }
  }
`;

export default S;
